import modelId from '../../../procedures/model-id.js';
import column from '../../abstract/column';
import form from '../../abstract/form.js';
import vars from '../../abstract/vars';
import actions from './actions';
import api, { modelName } from './api';
import { INVOICE_NUMBER_TEMPLATE_ADD_URL, INVOICE_NUMBER_TEMPLATE_LIST_URL } from './url.js';

export const priorityStatusOptions = {
  user: {
    value: 10,
    label: 'Użytkownika',
    color: 'primary',
  },
  systemDefault: {
    value: 20,
    label: 'Systemowy',
    color: 'primary',
  },
  userDefault: {
    value: 30,
    label: 'Domyślny',
    color: 'success',
  },
};

export default {
  actions,
  modelName,
  api,
  topRightActions: {
    create: {
      label: 'Dodaj numerację',
      icon: 'icon-plus',
      handle: async ({ $router }) => await $router.push(INVOICE_NUMBER_TEMPLATE_ADD_URL),
    },
  },
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    invoicetype: column({
      label: 'Typ faktury',
      format: item => item.invoicetype?.name,
      form: form({
        required: true,
        reverseTransform: ({ value }) => modelId(value),
      }),
      model: (models) => models.invoice.invoiceType,

    }),
    periodtype: column({
      label: 'Okres',
      format: item => item.periodtype?.name,
      form: form({
        required: true,
        reverseTransform: ({ value }) => modelId(value),
      }),
      model: (models) => models.invoice.periodType,
    }),
    pattern: column({
      label: 'Szablon',
      form: form({
        required: true,
        description: 'Użyj następujących symboli w wprowadzanym wzorze.\n' +
          '{NR} - numer faktury,\n' +
          '{M} - numer miesiąca,\n' +
          '{R} - rok.\n' +
          'Symbole zostaną zamienione na odpowiednie liczby w trakcie generowania numeru faktury.',
      }),
    }),
    priority: column({
      label: 'Typ',
      grid: true,
      component: 'value-status',
      options: priorityStatusOptions,
    }),
  },

  vars: vars({
    noItemsText: () => 'Brak elementów',
    sidebarLabel: () => 'Podgląd szablonu numerów',
    mainTabLabel: 'Szablon',
    softDelete: {
      title: 'Usunięcie szablonu',
      text: ({ id, pattern }) => `Czy na pewno chcesz usunąć szablon "${ pattern }" o id ${ id }?`,
      successText: 'Szablon został usunięty.',
    },
    onSuccessSave: async ({ $router }) => {
      await $router.push({
        path: INVOICE_NUMBER_TEMPLATE_LIST_URL,
      });
    },
  }),
};
